"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {on, hasClass, removeClass, findAll, find, findIn, findAllIn} from "@elements/dom-utils";

export function init() {
    onFind('.js-ajax-form__link-scroll', function (e){
        on('click', function (e){
            location.hash = "#ajax-form";
        }, e);
    });

    onFind('.js-ajax-form', function ($element) {
        on('fetch.ajax-form', function () {
            scrollTop($element);

            let $filterOverlay = findIn('.js-overlay', $element);
            if ($filterOverlay && hasClass('is-open', $filterOverlay)) {
                removeClass('is-open', $filterOverlay);
            }

        }, $element);

        let ajaxScrollTopButtons = findAllIn('.js-ajax-scroll-top', $element)
        if (ajaxScrollTopButtons) {
            ajaxScrollTopButtons.map(function (ajaxScrollTopBtn) {
                on('click', function () {
                    scrollTop($element);
                }, ajaxScrollTopBtn);
            });
        }
    });
}

export function scrollTop($element) {
    let navOffset = matchMedia('(max-width: 767px)').matches ? 150 : 200;
    let offset = $element.getBoundingClientRect().top + window.pageYOffset - navOffset;
    if (window.pageYOffset > offset) {
        try {
            window.scroll({
                top: offset,
                behavior: 'smooth'
            });
            console.log('scroooled')
        } catch (e) {
            window.scrollTo(0, offset)
        }
    }
}